var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#0072b2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_148",
    "data-name": "Layer 148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.65,337.12v74.05C599.65,515.3,515,600,410.85,600h-222C84.7,600,0,515.3,0,411.17v-222C0,85,84.7.28,188.81.28H263.3V130.87H188.81a58.41,58.41,0,0,0-58.23,58.25V411.17a58.4,58.4,0,0,0,58.23,58.24h222a58.41,58.41,0,0,0,58.23-58.24V337.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.62,342.62a65,65,0,0,1-46-111L458.3,51a65,65,0,0,1,91.93,91.92L369.58,323.58A64.75,64.75,0,0,1,323.62,342.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408.3.28H554.66a44.94,44.94,0,0,1,45,44.88v146c0,40-48.47,60-76.82,31.73L376.48,76.9C348.13,48.62,368.21.28,408.3.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external_link.708dbe81af55406b780df05d4e649ff7.svg";
export { ForwardRef as ReactComponent };